<template lang="html">
  <div class="slide" ref="scene">
    <svg class="canvas" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <clipPath id="clip-frame">
        <use xlink:href="#Frame"/>
      </clipPath>
      <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" style="stop-color:rgb(255,255,255);stop-opacity:0" />
        <stop offset="50%" style="stop-color:rgb(255,255,255);stop-opacity:1" />
        <stop offset="100%" style="stop-color:rgb(255,255,255);stop-opacity:1" />
      </linearGradient>
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <g ref="image" :transform-origin="`${canvasWidth/2} ${canvasHeight/2}`" clip-path="url(#clip-frame)">
        <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
          <picture>
            <source :srcset="`${publicPath}scenes/credits/BG-480w.jpg`" media="(max-width: 480px)">
            <source :srcset="`${publicPath}scenes/credits/BG-768w.jpg`" media="(max-width: 768px)">
            <source :srcset="`${publicPath}scenes/credits/BG-1280w.jpg`" media="(max-width: 1280px)">
            <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/credits/BG.jpg`" />
          </picture>
          </foreignObject>
      </g>
      <g clip-path="url(#clip-frame)">
        <rect
          ref="text-bg"
          fill="url(#grad1)"
          :x="canvasWidth" y="0"
          :width="canvasWidth"
          :height="canvasHeight" />
      </g>
    </svg>
    <SceneDialogue
      :width="0.4" :fontSize="22"
      :styles="{textAlign: `left`, fontFamily: `Minion Pro`}"
      :tx="1" :ty="0.5" :bg="`transparent`">
      <span class="ids">
        <span class='id head'>
          <span class='bold'>Stories told by an uncle and his niece</span><br>
          <span>Charlie Littlesalt & Lithuania Denetso</span>
        </span>
        <span class='id'>
          <span class='italic' style='display: inline-block;'>Created by The ONWARD Project</span>
        </span>
        <span class='id'>Book Concept by Louise Denetso</span>
        <span class='id'>Text Composition by Samantha Hasani</span>
        <span class='id'>Edited by Beryl Kahn and<br>
          <span class="indent">Mabelle Drake Hueston</span></span>
        <span class='id'>Illustrations by Shea Hueston</span>
        <span class='id'>Animation by Radha Vishnubhotla</span>
        <span class='id'>Website by Ben Benjamin</span>
      </span>
      <img ref="logo" class="logo" :src="`${publicPath}logos/logo.png`" />
    </SceneDialogue>
  </div>
</template>

<script>
import SceneDialogue from "../SceneDialogue.vue"
import Template from "./Template.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  mounted() {
    // this.tl = new TimelineLite({paused:true})

    TweenLite.set(this.$refs["image"], {opacity: 0})
    TweenLite.set(this.$refs["logo"], {opacity: 0})
    this.tl.add(TweenLite.to(this.$refs["image"], 1, {opacity: 1}))
    this.tl.add(TweenLite.to(this.$refs["text-bg"], 1, {x: -this.canvasWidth}))
    Array.from(this.$refs["scene"].querySelectorAll(".ids .id")).forEach((p, idx) => {
      TweenLite.set(p, {opacity: 0})
      this.tl.add(TweenLite.to(p, 1, {opacity: 1}), 2 + idx * 0.1)
    })
    this.tl.add(TweenLite.to(this.$refs["logo"], 1, {opacity: 1}), "-=1")
  },
  methods: {
    enter() { this.tl.play() },
  },
}
</script>

<style lang="scss" scoped>
/* .ids { display: none; } */
.id { display: block; margin-bottom: 1em; &:last-of-type { margin-bottom: 0px; } }
.head { margin-bottom: 1.5em; }
.indent { display: inline-block; margin-left: 3em; }
.logo { width: 80%; margin: 2em auto 0; }
</style>
